import { Injectable } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { ConfigurableFormComponent } from '../../../shared/modules/configurable-form/containers/configurable-form/configurable-form.component';
import { OnFieldChanged } from '../../../shared/modules/configurable-form/models/on-field-changed';
import { State } from '../../reducers';
import { Store } from '@ngrx/store';
import { OneClickLoadPlantsAction } from '../../actions/one-click-plants.actions';
import { IProduct } from '@cemex-core/cmx-api';

@Injectable()
export class OneClickLoadProductPlants implements OnFieldChanged {
  constructor(private store: Store<State>) {}

  onFieldChanged(value: IProduct, formGroup: UntypedFormGroup, form: ConfigurableFormComponent): void {
    if (value) {
      this.store.dispatch(new OneClickLoadPlantsAction(value, form.mapItem['index']));
    }
  }
}
